<template>
    <div class="m-content">

        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            {{ labels['stock_title'] }}
                        </h3>
                    </div>
                </div>
                <div class="m-portlet__head-tools">
                    <div id="m_quicksearch" m-quicksearch-mode="default" class="m-stack__item m-stack__item--middle m-dropdown m-dropdown--arrow m-dropdown--large m-dropdown--mobile-full-width m-dropdown--align-right m-dropdown--skin-light m-header-search m-header-search--expandable m-header-search--skin-light">
                        <form class="m-header-search__form">
                            <div class="m-header-search__wrapper">
                                <span id="m_quicksearch_search" class="m-header-search__icon-search"><i class="flaticon-search"></i></span>
                                <span class="m-header-search__input-wrapper">
                                    <input @keydown.enter.stop.prevent autocomplete="off" type="text" name="q" value="" placeholder="Search..." id="m_quicksearch_input" class="m-header-search__input" v-model="searchValue">
                                </span>
                                <span id="m_quicksearch_cancel" class="m-header-search__icon-cancel" @click="clearKeywords" v-show="keywords.length"><i class="la la-remove"></i></span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <filters :firstSearch="firstSearch"></filters>

            <div class="m-portlet__body">
                <div id="m_table_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer table-responsive">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_length" id="m_table_1_length">
                                <label>{{ labels['show'] }}
                                    <select name="m_table_1_length" aria-controls="m_table_1" class="custom-select custom-select-sm form-control form-control-sm" v-model.number="results.limit">
                                        <!--<option value="10">10</option>-->
                                        <option value="30">30</option>
                                        <option value="50">50</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!--begin: Datatable -->
                    <table class="table table-striped- table-bordered table-hover table-checkable" id="m_table_1">
                        <thead class="thead-light">
                        <tr>
                            <th class="sorting column_head">{{ labels['brand_name'] }}</th>
                            <th class="sorting column_head">{{ labels['collection_name'] }}</th>
                            <th class="sorting column_head">{{ labels['product_name'] }}</th>
                            <th class="sorting column_head">{{ labels['place_storage'] }}</th>
                            <th class="sorting column_head">{{ labels['open'] }}</th>
                            <th class="sorting column_head">{{ labels['loan'] }}</th>
                            <th class="sorting column_head">{{ labels['package_type'] }}</th>
                            <th class="sorting column_head">{{ labels['package_capacity'] }}</th>
                            <th class="sorting column_head">{{ labels['alert_status'] }}</th>
                            <th class="column_head">{{ labels['actions'] }}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <template v-for="(stock, index) in globalStocks">
                                <stock-row :key="'row_'+index" :stock="stock" :index="index"></stock-row>
                                <tr :key="'tr_' + index">
                                    <td colspan="11" v-if="openedIndex === index">
                                        <stock-form :key="'edit_'+index" :index="index" id="edit" :productId="stock.productId"></stock-form>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>

                    <div class="row pagination-footer">
                        <div class="col-sm-12 col-md-5">
                            <div class="dataTables_info" id="m_table_1_info" role="status" aria-live="polite">{{ labels['showing'] }} {{ resultsLength }} du {{ results.totalRecords }} entries</div>
                        </div>
                        <div class="col-sm-12 col-md-7">
                            <div class="dataTables_paginate paging_simple_numbers" id="m_table_1_paginate" v-show="results.totalPages > 1">
                                <ul class="pagination">
                                    <li class="paginate_button page-item pagination-word">{{ labels.page }}</li>
                                    <li class="pagination-btn" :class="{ 'paginate_button page-item previous': true, 'disabled': results.page <= 0 }" id="m_table_1_previous">
                                        <a href="#" aria-controls="m_table_1" data-dt-idx="0" tabindex="0" class="page-link" @click.prevent="previousPage" :disabled="results.page <= 0"><i class="la la-angle-left"></i></a>
                                    </li>
                                    <li class="paginate_button page-item"><input class="form-control pagination-input" type="text" :value="results.page + 1" @keyup.enter="changePage($event.target.value - 1)"></li>
                                    <li class="pagination-btn" :class="{ 'paginate_button page-item next': true, 'disabled': (results.page + 1) >= syncTotalPages }" id="m_table_1_next">
                                        <a href="#" aria-controls="m_table_1" data-dt-idx="6" tabindex="0" class="page-link" @click.prevent="nextPage" :disabled="(results.page + 1) >= syncTotalPages">
                                            <i class="la la-angle-right"></i>
                                        </a>                                </li>
                                    <li class="paginate_button page-item pagination-word">{{ labels.of }} {{ results.totalPages }}</li>
                                </ul>
                                <div style="width: 100px; background-color: #0a8cf0"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body new-product">
                <a href="#" class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon" data-target="#m_modal_addProduct" data-toggle="modal">
                    <span>
                        <i class="la la-plus"></i>
                        <span>{{ labels['add_a_product_to_stock'] }}</span>
                    </span>
                </a>
                <a  v-if="adminRole" href="#" class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon" data-target="#m_modal_imports" data-toggle="modal" @click.prevent="updateImportType('stocks')">
                    <span>
                        <i class="flaticon-upload"></i>
                        <span>{{ labels['import_stocks'] }}</span>
                    </span>
                </a>
            </div>
        </div>

        <modal name="addProduct"></modal>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import GetCRUDName from '../../assets/js/mixins'

import Modal from '../Modals/Modal'
import StockRow from './StockRow'
import Filters from './Filters'
import StockForm from './StockForm'

export default {
    name: 'StockList',
    mixins: [GetCRUDName],
    components: {
        Modal,
        StockRow,
        StockForm,
        Filters
    },
    data () {
        return {
            firstSearch: false
        }
    },
    watch: {
        refreshSearch () {
            this.updateStockList(null)
        },
        'results.limit' () {
            this.searchStocks()
        }
    },
    computed: {
        ...mapState({
            brands: store => store.crudData.cruds.brands,
            labels: store => store.labels,
            openedIndex: store => store.stocks.openedIndex,
            refreshSearch: store => store.stocks.refreshSearch,
            globalStocks: store => store.stocks.globalStocks,
            results: store => store.stocks.results,
            keywords: store => store.stocks.keywords
        }),
        ...mapGetters([
            'adminRole'
        ]),
        resultsLength () {
            return (this.results.limit * this.results.page) + ' - ' + ((this.results.limit * this.results.page) + this.globalStocks.length)
        },
        syncTotalPages () {
            if (this.globalStocks.length < this.results.limit && this.results.page === 0) {
                return 1
            } else {
                return this.results.totalPages
            }
        },
        searchValue: {
            get () {
                return this.keywords
            },
            set (value) {
                this.updateKeyword(value)
                // Close any edit boxes on search
                this.toggleTableView(null)
                // Send search request
                this.searchStocks({ page: 0 })
            }
        }
    },
    methods: {
        ...mapActions([
            'toggleTableView',
            'updateStockList',
            'updateImportType',
            'setGlobalStocks',
            'searchStocks',
            'updateKeyword'
        ]),
        changePage (page) {
            if (page >= 0 && (page + 1) <= this.syncTotalPages) {
                this.searchStocks({ page: page })
            }
        },
        previousPage () {
            this.searchStocks({ page: this.results.page - 1 })
        },
        nextPage () {
            this.searchStocks({ page: this.results.page + 1 })
        },
        clearKeywords () {
            this.searchValue = ''
        }
    },
    created () {
        // Perform 1st get-all product search
        // check if page is redirect from addToStock update. If yes we do not make request to algolia
        if (!this.$route.query.algoliaRefresh || this.$route.query.algoliaRefresh === 'true') {
            this.searchStocks({ firstSearch: true })
        }
        this.$router.replace({ name: 'StockList' })

        var my = this
        setTimeout(function () {
            my.firstSearch = true
        }, 500)
    }
}
</script>

<style scoped>
    .new-product {
        text-align: center;
    }
    .controls {
        font-size: 12px;
    }
    ._desc {
        display: inline-block;
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        transform: rotate(180deg);
        color: #33a3ff;
        position: absolute;
    }
    ._asc {
        display: inline-block;
        color: #33a3ff;
        position: absolute;
    }
    .sort {
        display: inline-block;
        position: absolute;
    }

    .column_head {
        vertical-align: top;
    }

    .table_icon {
        display: inline-block;
    }

    .pagination-footer {
        margin-bottom: 4%;
    }

    .pagination-input {
        width: 55px;
    }

    .pagination-word {
        margin-top: 2%;
    }

    .pagination-btn {
        margin-top: 1%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stocks/StockList.vue